function InsertRecaptchaScript() {
  setTimeout(function () {
    var recaptchaScript = document.createElement("script");
    recaptchaScript.src =
      "https://www.google.com/recaptcha/api.js?render=6LcoAZorAAAAABagcN95ntcpzfgpcIlFLA3_4_aV";
    recaptchaScript.async = true;
    document.body.appendChild(recaptchaScript);
  }, 3000);
}

export default InsertRecaptchaScript;
